<template>
    <div class="row justify-content-center no-gutters">
        <Loading
        :active.sync="isLoading"
        :can-cancel="false"
        is-full-page="true"
        background-color="#000"
        color="#fff"
        ></Loading>
        <div class="col col-md-9">
            <div class="card bookings-widget-card my-4 " v-if="bookings.length > 0">
                <div class="card-body bookings-wrapper">
                    <div class="mb-3">My Bookings</div>
                    <div class="card bookings-widget-card mb-3" v-for="(booking, index) in bookings" :key="index">
                        <div class="card-body bookings-content">
                            <div class="container">
                                <div class="row">
                                    <div class="col-6">Region: {{ booking.event_region }}</div>
                                    <div class="col-6 text-right">
                                        <span class="badge badge-primary booking-status">{{ booking.status }}</span>
                                    </div>
                                    <div class="col-12">Event: {{ booking.event_type }}</div>
                                    <div class="col-12">Booking Date: {{ booking.start_date | toDateToString }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="text-center">
                No bookings found.
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";

export default {
    props: ['user'],
    data() {
        return {
            bookings: [],
            bookingStatus: ['Registered', 'Cancelled'],
            isUpdateButton: false,
            currentId: '',
            isUpdating: false,
            isLoading: false,
        }
    },
    components: {
        Loading
    },
    created() {
        this.getBookings()
    },
    methods: {
        getBookings() {
            this.isLoading = true

            axios.get('/widget/get-bookings/' + this.user.email)
                .then(response => {
                    this.isLoading = false
                    this.bookings = response.data.data
                })
                .catch(error => {
                    this.isLoading = false
                    this.$toasted.show(error, {
                        type : 'error',
                        position: 'top-center',
                        duration: 3000,
                    })
                })
        },
        updateBookingStatus(id, status) {
            this.isUpdating = true

            const request = {
                id: id,
                email: this.user.email,
                status: status
            }

            axios.post('/widget/update-booking-status', request)
                .then(response => {
                    let data = response.data

                    if (typeof data.status_code != 'undefined' && data.status_code == 200) {
                        this.isUpdating = false
                        this.currentId = ''
                        this.getBookings()

                        this.$toasted.show('Status has been updated successfully!', {
                            type : 'success',
                            position: 'bottom-center',
                            duration: 3000,
                        })
                    } else {
                        this.isUpdating = false
                        this.$toasted.show(data.error_message, {
                            type : 'error',
                            position: 'bottom-center',
                            duration: 3000,
                        })
                    }
                })
                .catch(error => {
                    this.isUpdating = false
                    this.$toasted.show(error, {
                        type : 'error',
                        position: 'bottom-center',
                        duration: 3000,
                    })
                })
        },
        updateButton(id) {
            this.currentId = id
        }
    },
    filters: {
        toDateToString(date) {
            return moment(date).format('MMMM Do YYYY')
        }
    }
}
</script>

<style scope>
.bookings-wrapper {
    background: #234974 !important;
}
.bookings-content {
    background: #12253C !important;
}
.bookings-widget-card {
    border: 0px !important;
}
.booking-status {
    color: #5F954B;
    text-transform: uppercase;
    padding: 5px 10px;
    border: 1px #5F954B solid;
    background: transparent;
}

.bookings-widget-card{
    background: none !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Tabs/Bookings.vue